import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { store } from "../../redux/oldStore";
import redux, { IState } from "../../redux/redux";
import { ServerResponse } from "../../utils/Server";

interface IFirstTimeCompleteProps extends IState{
  Type: "FirstTime" | "ProfileUpdate";
}
const FirstTimeLoginComplete = (props:IFirstTimeCompleteProps) => {
  const { targetId } = useParams();
  const [pageText, setPageText] = useState("");

  useEffect(() => {
    if(props.Settings?.text){
      switch (props.Type) {
        case "FirstTime":
          setPageText(props.Settings?.text.FirstTimeLoginCompletePageBody);
          break;
        case "ProfileUpdate":
          setPageText(props.Settings?.text.ProfileUpdateCompletePageBody);
          break;
      }
    }
  }, [props.Settings]);

  useEffect(()=>{
    if (!targetId) {
      redux.LoadSettings(true);
      return;
    }
    store.server
      .postApi<ServerResponse<unknown>>(`../userProfile/Done`, { userId: targetId })
      .finally(() => {
        redux.LoadSettings(true);
      });
  },[targetId]);

  return (
    <>
      <div className="col-sm-12">
        <h3>Thank you</h3>
        <hr />
        {pageText && <div dangerouslySetInnerHTML={{ __html: pageText }} />}
      </div>
    </>
  );
};

//export default ReduxMap(FirstTimeLoginComplete);
const mapStateToProps = (state) => {
  return { ...state.main };
};

export default connect(mapStateToProps)(FirstTimeLoginComplete);

